/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const credentialsSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common:Credentials',
    type: 'object',
    properties: {
        credentialsType: {
            type: 'string',
            enum: [
                'oauth',
                'userPassword',
                's3Credentials',
                'apiKey',
                'symon',
                'awsRoleAssumption',
                'rest',
                'tokenBasedAuthentication'
            ]
        }
    },
    required: ['credentialsType']
};
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:Credentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.credentialsType === undefined && (missing0 = 'credentialsType')) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credentialsType !== undefined) {
                    let data0 = data.credentialsType;
                    if (typeof data0 !== 'string') {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'oauth' ||
                        data0 === 'userPassword' ||
                        data0 === 's3Credentials' ||
                        data0 === 'apiKey' ||
                        data0 === 'symon' ||
                        data0 === 'awsRoleAssumption' ||
                        data0 === 'rest' ||
                        data0 === 'tokenBasedAuthentication')) {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/credentialsType',
                                schemaPath: '#/properties/credentialsType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema29.properties.credentialsType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const incentivesComposerS3ConfigSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common:IncentivesComposerS3Config',
    type: 'object',
    properties: {
        credentials: { $ref: 'urn:wisepipe-common:S3Credentials' },
        location: { $ref: 'urn:wisepipe-common:S3File' }
    },
    required: ['credentials', 'location']
};
const schema31 = {
    $id: 'urn:wisepipe-common:S3Credentials',
    type: 'object',
    properties: {
        accessKey: { type: 'string', minLength: 1 },
        secret: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 }
    },
    required: ['accessKey', 'secret']
};
const schema32 = {
    $id: 'urn:wisepipe-common:S3File',
    type: 'object',
    properties: {
        bucket: { type: 'string', minLength: 1 },
        key: { type: 'string', minLength: 1 },
        uploadID: { type: 'string', uid: 9 }
    },
    required: ['bucket', 'key']
};
const func2 = ucs2length;
const func7 = ucs2length;
const func8 = base64urlToBuffer;
const func9 = base64urlEncode;
const func10 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:IncentivesComposerS3Config" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.credentials === undefined && (missing0 = 'credentials')) ||
                (data.location === undefined && (missing0 = 'location'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credentials !== undefined) {
                    let data0 = data.credentials;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.accessKey === undefined && (missing1 = 'accessKey')) ||
                                (data0.secret === undefined && (missing1 = 'secret'))) {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/credentials',
                                        schemaPath: 'urn:wisepipe-common:S3Credentials/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.accessKey !== undefined) {
                                    let data1 = data0.accessKey;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/accessKey',
                                                        schemaPath: 'urn:wisepipe-common:S3Credentials/properties/accessKey/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/credentials/accessKey',
                                                    schemaPath: 'urn:wisepipe-common:S3Credentials/properties/accessKey/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.secret !== undefined) {
                                        let data2 = data0.secret;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/credentials/secret',
                                                            schemaPath: 'urn:wisepipe-common:S3Credentials/properties/secret/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/secret',
                                                        schemaPath: 'urn:wisepipe-common:S3Credentials/properties/secret/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.sessionToken !== undefined) {
                                            let data3 = data0.sessionToken;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate13.errors = [
                                                            {
                                                                instancePath: instancePath + '/credentials/sessionToken',
                                                                schemaPath: 'urn:wisepipe-common:S3Credentials/properties/sessionToken/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/credentials/sessionToken',
                                                            schemaPath: 'urn:wisepipe-common:S3Credentials/properties/sessionToken/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/credentials',
                                    schemaPath: 'urn:wisepipe-common:S3Credentials/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.location !== undefined) {
                        let data4 = data.location;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                let missing2;
                                if ((data4.bucket === undefined && (missing2 = 'bucket')) ||
                                    (data4.key === undefined && (missing2 = 'key'))) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/location',
                                            schemaPath: 'urn:wisepipe-common:S3File/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data4.bucket !== undefined) {
                                        let data5 = data4.bucket;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/location/bucket',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/location/bucket',
                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/bucket/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs13 === errors;
                                    }
                                    else {
                                        var valid4 = true;
                                    }
                                    if (valid4) {
                                        if (data4.key !== undefined) {
                                            let data6 = data4.key;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) < 1) {
                                                        validate13.errors = [
                                                            {
                                                                instancePath: instancePath + '/location/key',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/key/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/location/key',
                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/key/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid4 = _errs15 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                        if (valid4) {
                                            if (data4.uploadID !== undefined) {
                                                let data7 = data4.uploadID;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (typeof data7 === 'string') {
                                                        const b64min0 = Math.ceil((4 * 9) / 3);
                                                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                        if (func7(data7) < b64min0 || func7(data7) > b64max0) {
                                                            validate13.errors = [
                                                                {
                                                                    instancePath: instancePath + '/location/uploadID',
                                                                    schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func7(data7) },
                                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func7(data7)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded0 = func8(data7);
                                                            if (decoded0.length !== 9) {
                                                                validate13.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/location/uploadID',
                                                                        schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 9 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded0 = func9(decoded0);
                                                                if (func10(encoded0) !== func10(data7)) {
                                                                    validate13.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/location/uploadID',
                                                                            schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate13.errors = [
                                                            {
                                                                instancePath: instancePath + '/location/uploadID',
                                                                schemaPath: 'urn:wisepipe-common:S3File/properties/uploadID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs17 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/location',
                                        schemaPath: 'urn:wisepipe-common:S3File/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const pagedResponseSchemaValidation = validate14;
const schema33 = {
    $id: 'urn:wisepipe-common:PagedResponse',
    type: 'object',
    properties: { continuationToken: { type: 'string' }, items: { type: 'array', items: { type: 'object' } } },
    required: ['items']
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:PagedResponse" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.items === undefined && (missing0 = 'items')) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.continuationToken !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.continuationToken !== 'string') {
                        validate14.errors = [
                            {
                                instancePath: instancePath + '/continuationToken',
                                schemaPath: '#/properties/continuationToken/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.items !== undefined) {
                        let data1 = data.items;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/items/' + i0,
                                                schemaPath: '#/properties/items/items/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/items',
                                        schemaPath: '#/properties/items/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const s3CredentialsSchemaValidation = validate15;
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3Credentials" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.accessKey === undefined && (missing0 = 'accessKey')) ||
                (data.secret === undefined && (missing0 = 'secret'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.accessKey !== undefined) {
                    let data0 = data.accessKey;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/accessKey',
                                        schemaPath: '#/properties/accessKey/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/accessKey',
                                    schemaPath: '#/properties/accessKey/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.secret !== undefined) {
                        let data1 = data.secret;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/secret',
                                            schemaPath: '#/properties/secret/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/secret',
                                        schemaPath: '#/properties/secret/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.sessionToken !== undefined) {
                            let data2 = data.sessionToken;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/sessionToken',
                                                schemaPath: '#/properties/sessionToken/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/sessionToken',
                                            schemaPath: '#/properties/sessionToken/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const s3FileSchemaValidation = validate16;
const func16 = ucs2length;
const func17 = base64urlToBuffer;
const func18 = base64urlEncode;
const func19 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:S3File" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) || (data.key === undefined && (missing0 = 'key'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    let data0 = data.bucket;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/bucket',
                                        schemaPath: '#/properties/bucket/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/bucket',
                                    schemaPath: '#/properties/bucket/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.key !== undefined) {
                        let data1 = data.key;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/key',
                                            schemaPath: '#/properties/key/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.uploadID !== undefined) {
                            let data2 = data.uploadID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func16(data2) < b64min0 || func16(data2) > b64max0) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/uploadID',
                                                schemaPath: '#/properties/uploadID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func16(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func16(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func17(data2);
                                        if (decoded0.length !== 9) {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/uploadID',
                                                    schemaPath: '#/properties/uploadID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func18(decoded0);
                                            if (func19(encoded0) !== func19(data2)) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/uploadID',
                                                        schemaPath: '#/properties/uploadID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/uploadID',
                                            schemaPath: '#/properties/uploadID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const sortParamsSchemaValidation = validate17;
const schema36 = {
    $id: 'urn:wisepipe-common:SortParams',
    type: 'object',
    properties: { sortBy: { type: 'string' }, sortDir: { type: 'string', enum: ['asc', 'desc'] } },
    required: ['sortBy', 'sortDir']
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:SortParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.sortBy === undefined && (missing0 = 'sortBy')) ||
                (data.sortDir === undefined && (missing0 = 'sortDir'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sortBy !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.sortBy !== 'string') {
                        validate17.errors = [
                            {
                                instancePath: instancePath + '/sortBy',
                                schemaPath: '#/properties/sortBy/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.sortDir !== undefined) {
                        let data1 = data.sortDir;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/sortDir',
                                    schemaPath: '#/properties/sortDir/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'asc' || data1 === 'desc')) {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/sortDir',
                                    schemaPath: '#/properties/sortDir/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema36.properties.sortDir.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const statusRecordSchemaValidation = validate18;
const schema37 = {
    $id: 'urn:wisepipe-common:StatusRecord',
    type: 'object',
    properties: {
        createdAt: { type: 'number' },
        expiredAt: { type: 'number' },
        processID: { type: 'string' },
        serviceType: { type: 'string', enum: ['import', 'calc', 'export', 'pipe', 'auth', 'run'] },
        status: { type: 'string', enum: ['completed', 'failed'] },
        durationInSeconds: { type: 'number' }
    },
    required: ['createdAt', 'expiredAt', 'serviceType', 'status']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common:StatusRecord" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.createdAt === undefined && (missing0 = 'createdAt')) ||
                (data.expiredAt === undefined && (missing0 = 'expiredAt')) ||
                (data.serviceType === undefined && (missing0 = 'serviceType')) ||
                (data.status === undefined && (missing0 = 'status'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.createdAt !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.createdAt == 'number')) {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/createdAt',
                                schemaPath: '#/properties/createdAt/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.expiredAt !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.expiredAt == 'number')) {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/expiredAt',
                                    schemaPath: '#/properties/expiredAt/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.processID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.processID !== 'string') {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/processID',
                                        schemaPath: '#/properties/processID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.serviceType !== undefined) {
                                let data3 = data.serviceType;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/serviceType',
                                            schemaPath: '#/properties/serviceType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'import' ||
                                    data3 === 'calc' ||
                                    data3 === 'export' ||
                                    data3 === 'pipe' ||
                                    data3 === 'auth' ||
                                    data3 === 'run')) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/serviceType',
                                            schemaPath: '#/properties/serviceType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema37.properties.serviceType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.status !== undefined) {
                                    let data4 = data.status;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate18.errors = [
                                            {
                                                instancePath: instancePath + '/status',
                                                schemaPath: '#/properties/status/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'completed' || data4 === 'failed')) {
                                        validate18.errors = [
                                            {
                                                instancePath: instancePath + '/status',
                                                schemaPath: '#/properties/status/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema37.properties.status.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.durationInSeconds !== undefined) {
                                        const _errs11 = errors;
                                        if (!(typeof data.durationInSeconds == 'number')) {
                                            validate18.errors = [
                                                {
                                                    instancePath: instancePath + '/durationInSeconds',
                                                    schemaPath: '#/properties/durationInSeconds/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map